import styled from 'styled-components'
import {Button, Grid} from 'antd';
import {RightOutlined} from '@ant-design/icons';
import {useMemo} from 'react';
import {TeamLogo} from "./TeamLogo";
import {useNavigate} from "react-router-dom";
import {Apply} from "./Apply";

const {useBreakpoint} = Grid

const ItemWrap = styled.div`
    display: flex;
    padding: 29px 35px;
    @media screen and (max-width: 768px) {
      padding: 15px 17px;
    }
    background: #0E0E0E;
    border-radius: 5px;
    align-items: center;
    & + & {
      margin-top: 20px;
    }
    .anticon {
      color: #6DE6C5;
    }
`

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 24px;
  flex: 0 120px;
  margin-left: 23px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    margin: 0;
  }
`

const Desc = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 24px;
  margin-left: 9%;
  margin-right: 10%;
  flex: 1;
  @media screen and (max-width: 768px) {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 60vw;
    color: #4B555E;
  }
`

const DetailButton = styled(Button)`
    height: 40px !important;
    border-radius: 20px !important;
    border-color: #6ee6c6 !important;
    color:#6ee6c6 !important;
    padding: 0 33px;
    &:hover{
        border-color: #6ee6c6 !important;
        background-color: #6ee6c6 !important;
        color:#000 !important;
    };
    &:focus-within{
        border-color: #6ee6c6 !important;
        background-color: #6ee6c6 !important;
        color:#000 !important;
    }
`

const Content = styled.div`
  flex: 1;
  display: flex;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    display: inline-block;
    padding-left: 16px;
  }
`

const LogoWrapper = styled.div`
  cursor: pointer;
`

export const TeamItem = ({team, userMemberStatus}) => {
    const navigate = useNavigate()
    const breakpoint = useBreakpoint();

    const isMobile = useMemo(() => {
        return breakpoint.xs || (breakpoint.sm && !breakpoint.md)
    }, [breakpoint])

    return (
        <ItemWrap>
            <LogoWrapper>
                <TeamLogo onClick={() => navigate(`/whitehat-teams/${team.title}`)} logo={team.logo_file} size={isMobile ? 40 : 60} />
            </LogoWrapper>
            <Content isMobile={isMobile} onClick={() => navigate(`/whitehat-teams/${team.title}`)}>
                <Title>{team.title}</Title>
                <Desc>{team.summary}</Desc>
            </Content>
            {
                !isMobile ? (
                    // <DetailButton onClick={() => navigate(`/whitehat-teams/${team.title}`)}>Learn More</DetailButton>
                    <Apply userMemberStatus={userMemberStatus} team={team} />
                ) : <RightOutlined />
            }
        </ItemWrap>
    )
}
